export const getApiErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const apiError = error as {
    status?: number;
    statusCode?: number;
    response?: { status?: number };
  };

  return apiError.status ?? apiError.statusCode ?? apiError.response?.status;
};

const readDetail = (body: unknown): string | undefined => {
  if (typeof body === 'string') {
    try {
      return readDetail(JSON.parse(body));
    } catch {
      return undefined;
    }
  }

  if (body && typeof body === 'object') {
    const detail = (body as { detail?: unknown }).detail;
    return typeof detail === 'string' && detail ? detail : undefined;
  }

  return undefined;
};

/**
 * Returns the `detail` of a ProblemDetails error answer, or `undefined` when there is none.
 * Reads Axios errors (`error.response.data.detail`), NSwag `ApiException` (`response` as a JSON string,
 * or `result`) and a ProblemDetails object thrown as is (`error.detail`).
 */
export const getApiErrorDetail = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const apiError = error as {
    detail?: unknown;
    response?: unknown;
    result?: unknown;
  };

  const ownDetail = readDetail(apiError);
  if (ownDetail) return ownDetail;

  const axiosData =
    apiError.response && typeof apiError.response === 'object' ? (apiError.response as { data?: unknown }).data : undefined;

  return readDetail(axiosData) ?? readDetail(apiError.response) ?? readDetail(apiError.result);
};
